<template>
    <form-container headerText="Tabellenkorrektur" :width="860" action="editSaisonTable"
                    :valid-actions="['editSaisonTable']" @save="save()">
        <div v-if="dataObject" class="px-7 pb-3 white">
            <div class="font-weight-bold text-h6 mb-3">{{ligaName}} / {{sportJahrText}}</div>
            <div style="width: 100%; overflow-x: scroll">
                <table class="white">
                    <tr>
                        <th class="text-left">Mannschaft</th>
                        <th>Spiele</th>
                        <th>S</th>
                        <th>U</th>
                        <th>N</th>
                        <th>SaP gew.</th>
                        <th>SaP verl.</th>
                        <th>Map gew.</th>
                        <th>Map verl.</th>
                        <th>Pkt</th>
                    </tr>
                    <tr v-for="(team, i) in dataObject.teamsList" :key="i">
                        <td><div class="text-no-wrap body-2 mr-2">{{team.name}}</div></td>
                        <td>
                            <v-text-field v-model="team.spiele" hide-details outlined dense type="number"
                                          style="min-width: 50px">
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="team.siege" hide-details outlined dense type="number"
                                          style="min-width: 44px">
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="team.unentschieden" hide-details outlined dense type="number"
                                          style="min-width: 44px">
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="team.niederlagen" hide-details outlined dense type="number"
                                          style="min-width: 44px">
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="team.satzpunkteS" hide-details outlined dense type="number"
                                          style="min-width: 66px">
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="team.satzpunkteN" hide-details outlined dense type="number"
                                          style="min-width: 66px">
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="team.mannschaftsPunkteS" hide-details outlined dense type="number"
                                          style="min-width: 52px">
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="team.mannschaftsPunkteN" hide-details outlined dense type="number"
                                          style="min-width: 52px">
                            </v-text-field>
                        </td>
                        <td>
                            <v-text-field v-model="team.tabPkt" hide-details outlined dense type="number"
                                          style="min-width: 44px">
                            </v-text-field>
                        </td>
                    </tr>
                </table>
            </div>
            <error-msg :error="error"></error-msg>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "@/components/form/formContainer";
    import ErrorMsg from "@/components/elements/errorMsg";
    import {SaisonTable} from "@/services/data/saisonTable";

    export default {
        components: {
            ErrorMsg,
            FormContainer},
        name: "saison-edit-table",
        props: ['currentData', 'sportJahr'],
        data: () => ({
            dataObject: null,
            error: '',
        }),
        computed: {
            sportJahrText(){ return this.sportJahr.replace('_', '/') },
            ligaName() {return this.$store.state.realtime.landesverbaende[this.currentData.lvId]
                                    .ligen[this.currentData.ligaId].nameFull}
        },
        created(){
            if ( this.currentData && this.currentData.teams ) {
                this.dataObject = new SaisonTable(this.currentData.teams);
            }
        },
        methods: {
            async save(){
                this.$store.state.local.loader = true;
                const reply = await this.dataObject.saveTable(this.currentData.id);
                if ( reply.successful ) {
                    window.history.back();
                } else {
                    this.error = reply.content
                }
                this.$store.state.local.loader = false;
            },
        },
    }
</script>

<style scoped>

</style>